define('components/course/models/slide-type/theme-selection',[
    'components/course/models/slide-type/base'
], function (Base) {
    "use strict";

    return Base;
});

